<div *transloco="let t; scope: 'featureDataManagement'">
  <span id="currency-label" class="block bd-mb-12">
    {{ t('featureDataManagement.attributesEditor.selectCurrency.label') }}
  </span>

  <p-select
    data-id="currency-selector"
    [options]="currencyOptions"
    [(ngModel)]="selectedOption"
    [placeholder]="
      t('featureDataManagement.attributesEditor.selectCurrency.placeholder')
    "
    class="w-full"
    ariaLabelledBy="currency-label"
    (onChange)="onCurrencyChange($event)"
  >
    <ng-template #selectedItem let-selectedOption>
      <span
        >{{ selectedOption
        }}<span class="bd-grayed-out" data-id="currency-description">
          ({{
            t(
              'featureDataManagement.attributesEditor.selectCurrency.currencyCodes.' +
                selectedOption +
                '.description'
            )
          }})</span
        ></span
      >
    </ng-template>
    <ng-template #item let-option>
      <span
        >{{ option }}
        <span class="bd-grayed-out">
          ({{
            t(
              'featureDataManagement.attributesEditor.selectCurrency.currencyCodes.' +
                option +
                '.description'
            )
          }})</span
        ></span
      >
    </ng-template>
  </p-select>
</div>
